import { z } from "zod/v4";

import { createZodNumberOption } from "components/Forms/utils/validation.utils";

const NewVidSchema = z.object({
  is_resubmission: z.literal(false),
  previous_vid: z.array(createZodNumberOption()).length(0),
});

const PreviousVidSchema = z.object({
  is_resubmission: z.literal(true),
  previous_vid: z
    .array(createZodNumberOption())
    .min(1, "Please select at least one previous VID"),
});

export const SubmissionTypeSchema = z.discriminatedUnion("is_resubmission", [
  NewVidSchema,
  PreviousVidSchema,
]);

export const SubmissionTypeDraftSchema = z.object({
  is_resubmission: z.boolean(),
  previous_vid: z.array(createZodNumberOption()),
});
